// Module 3: Red Flag Detection.
// Receives extracted facts + QA findings. Produces a list of red flags ranked by severity.

export function buildRedFlagsMessage({ facts, qaText, fileName }) {
  return `Customer file under review: ${fileName || 'untitled'}

--- EXTRACTED FACTS (JSON) ---
${JSON.stringify(facts, null, 2)}

--- KYC QA ASSESSMENT FINDINGS ---
${qaText}

--- END INPUTS ---

Now identify the red flags using the exact format specified in your instructions. Be conservative — false negatives are catastrophic. If something looks off, flag it.`;
}
